import React from 'react'
import styled from 'styled-components';
import { OsIcon } from '../OsIcon';

const SubTitle = styled.div`
  display: inline-block;
  vertical-align: text-top;
  line-height: 0.7;
`

const BundleIdField = styled.small`
  text-transform: none;
  font-size: 0.6em;
`

const AppNameField = styled.span`
  line-height: 1;
`

const AppSubTitle = ({app}) => {
  return ( <>
    <OsIcon os={app.os} />
    <SubTitle>
      <AppNameField>
        &nbsp;{app.name || app.bundle_id}
      </AppNameField>
      {app.name && <BundleIdField>
        &nbsp;({app.bundle_id})
      </BundleIdField>}
    </SubTitle>
  </> );
}

export default AppSubTitle;
